import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ResPillStatus } from '../res-pill/res-pill.component';

// MatrixStatus teilt die Union mit ResPillStatus — dieselben sechs Werte,
// darunter `not-run` fuer nie ausgefuehrte Testfaelle (NEX-1085 Review W1).
export type MatrixStatus = ResPillStatus;

const ICON: Record<MatrixStatus, string> = {
  passed: 'check',
  failed: 'close',
  blocked: 'shield',
  running: 'settings',
  skipped: 'chevron_right',
  'not-run': 'radio_button_unchecked',
};

@Component({
  selector: 'app-matrix-cell',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span
      class="matrix-cell"
      role="img"
      [attr.data-status]="status()"
      [attr.title]="tooltip()"
      [attr.aria-label]="tooltip()"
      data-testid="matrix-cell"
    >
      <span class="matrix-cell__icon material-icons" aria-hidden="true">{{ icon() }}</span>
    </span>
  `,
  styles: `
    :host {
      display: inline-flex;
    }

    .matrix-cell {
      width: 1.625rem;
      height: 1.625rem;
      border-radius: 0.375rem;
      display: grid;
      place-items: center;
      flex-shrink: 0;
      background: var(--to-slate-bg);
    }

    .matrix-cell[data-status='passed'] {
      background: var(--to-green-bg);
    }
    .matrix-cell[data-status='failed'] {
      background: var(--to-red-bg);
    }
    .matrix-cell[data-status='running'] {
      background: var(--to-blue-bg);
    }
    .matrix-cell[data-status='blocked'] {
      background: var(--to-warn-bg);
    }

    .matrix-cell__icon {
      font-size: 0.8125rem;
      color: var(--to-slate-dot-soft);
    }
    .matrix-cell[data-status='passed'] .matrix-cell__icon {
      color: var(--to-green-dot);
    }
    .matrix-cell[data-status='failed'] .matrix-cell__icon {
      color: var(--to-chart-failed);
    }
    .matrix-cell[data-status='running'] .matrix-cell__icon {
      color: var(--to-blue-dot);
    }
    .matrix-cell[data-status='blocked'] .matrix-cell__icon {
      color: var(--to-amber-deep);
    }
    .matrix-cell[data-status='not-run'] {
      background: var(--to-gray-bg);
    }
    .matrix-cell[data-status='not-run'] .matrix-cell__icon {
      color: var(--to-gray-dot);
    }
  `,
})
export class MatrixCellComponent {
  readonly status = input.required<MatrixStatus>();
  // Pflicht (NEX-1085 Review W3, WCAG 2.1 AA 1.1.1/1.4.1): der Screenreader-
  // Text ist der einzige nicht-farbliche Kanal, den die Zelle hat.
  readonly tooltip = input.required<string>();
  readonly icon = computed(() => ICON[this.status()]);
}
